import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { FaFacebookF, FaInstagram, FaWhatsapp } from 'react-icons/fa6';
import newlogo from '../assets/newlogo.png';

const COLUMNS = [
  {
    title: 'Safaris',
    links: [
      { name: 'All safaris', to: '/safaris' },
      { name: 'Kenya', to: '/safaris/kenya' },
      { name: 'Tanzania', to: '/safaris/tanzania' },
      { name: 'Rwanda', to: '/safaris/rwanda' },
      { name: 'South Africa', to: '/safaris/southafrica' },
      { name: 'Zanzibar', to: '/safaris/zanzibar' },
    ],
  },
  {
    title: 'Explore',
    links: [
      { name: 'Excursions', to: '/excursions' },
      { name: 'Stays', to: '/directory' },
      { name: 'Car Hire', to: '/car-hire' },
      { name: 'Destinations & parks', to: '/destinations' },
      { name: 'Blog', to: '/blog' },
    ],
  },
  {
    title: 'Company',
    links: [
      { name: 'About', to: '/about' },
      { name: 'Contact', to: '/contact' },
      { name: 'Plan your trip', to: '/enquire' },
      { name: 'FAQ', to: '/faq' },
      { name: 'Terms', to: '/terms' },
    ],
  },
];

const SOCIAL = [
  { name: 'Facebook', icon: <FaFacebookF size={15} />, href: 'https://www.facebook.com/Jambo.travel.Safaris?_rdc=1&_rdr' },
  { name: 'Instagram', icon: <FaInstagram size={15} />, href: 'https://www.instagram.com/jambo_travelhouse/' },
  { name: 'WhatsApp', icon: <FaWhatsapp size={15} />, href: 'https://wa.me/254112666696' },
];

const PARTNERS = [
  { alt: 'Safari Bookings', src: 'https://cfstatic.safaribookings.com/img/logos/logo-240x35.png', href: 'https://www.safaribookings.com/p5824' },
  { alt: 'SafariGo', src: 'https://image.safarigo.com/safarigo/logo-w.png', href: 'https://www.safarigo.com/operator/jambo-travelhouse-holidays-limited--1761' },
  { alt: 'Tripadvisor', src: 'https://static.tacdn.com/img2/brand_refresh/Tripadvisor_lockup_horizontal_secondary_registered.svg', href: 'https://www.tripadvisor.com/Attraction_Review-g294207-d18843478-Reviews-Jambo_Travelhouse_Holidays-Nairobi.html' },
];

const Footer = () => (
  <footer className="bg-cafe-noir text-eggshell">
    <div className="max-w-6xl mx-auto px-6 md:px-8 py-16 md:py-20">
      <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        {/* Brand + contact */}
        <div className="lg:pr-4">
          <img src={newlogo} alt="Jambo Travel House Holidays" className="w-32 mb-6" />
          <p className="text-sm text-eggshell/60 leading-relaxed mb-6 max-w-xs">Tailor-made African safaris across Kenya, Tanzania, Rwanda, South Africa and Zanzibar — planned by people who live it.</p>
          <div className="space-y-2.5 text-sm">
            <a href="mailto:tours@jambotravelhouse.co.ke" className="flex items-center gap-2.5 text-eggshell/75 hover:text-hunyadi-yellow transition-colors"><Mail size={15} className="text-hunyadi-yellow shrink-0" />tours@jambotravelhouse.co.ke</a>
            <a href="tel:+254112666696" className="flex items-center gap-2.5 text-eggshell/75 hover:text-hunyadi-yellow transition-colors"><Phone size={15} className="text-hunyadi-yellow shrink-0" />+254 112 666 696</a>
            <p className="flex items-center gap-2.5 text-eggshell/75"><MapPin size={15} className="text-hunyadi-yellow shrink-0" />Nairobi, Kenya</p>
          </div>
          <div className="flex gap-3 mt-6">
            {SOCIAL.map((s) => (
              <a key={s.name} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.name}
                className="w-9 h-9 rounded-full border border-eggshell/15 flex items-center justify-center text-eggshell/80 hover:bg-hunyadi-yellow hover:text-cafe-noir hover:border-hunyadi-yellow transition-colors">
                {s.icon}
              </a>
            ))}
          </div>
        </div>

        {/* Link columns */}
        {COLUMNS.map((col) => (
          <div key={col.title}>
            <p className="text-xs uppercase tracking-[0.2em] text-hunyadi-yellow mb-5">{col.title}</p>
            <ul className="space-y-2.5">
              {col.links.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-eggshell/70 hover:text-hunyadi-yellow transition-colors">{l.name}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Partners */}
      <div className="mt-14 pt-10 border-t border-eggshell/10">
        <p className="text-xs uppercase tracking-[0.2em] text-eggshell/40 text-center mb-6">Reviewed &amp; listed on</p>
        <div className="flex flex-wrap items-center justify-center gap-6">
          {PARTNERS.map((p) => (
            <a key={p.alt} href={p.href} target="_blank" rel="noopener noreferrer" aria-label={p.alt} className="opacity-70 hover:opacity-100 transition-opacity">
              <img src={p.src} alt={p.alt} loading="lazy" className="h-8 object-contain bg-eggshell/95 rounded px-2 py-1" />
            </a>
          ))}
        </div>
      </div>
    </div>

    {/* Bottom bar */}
    <div className="border-t border-eggshell/10">
      <div className="max-w-6xl mx-auto px-6 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-eggshell/50">
        <p>© 2026 Jambo Travel House Holidays. All rights reserved.</p>
        <p>Developed by Alex Irungu</p>
      </div>
    </div>
  </footer>
);

export default Footer;
